export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-v1-960-b47795e0187e10758b35c189b8bd4e85.webp";